import { SendOfferToAnvaBySessionIdResponse } from 'wg-api-sdk';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { wgApi } from '../../../../app/src/features/api/wgApi';
import { ErrorResponse } from '../../../../../types/API';

interface Params {
  queryOptions?: UseMutationOptions<
    SendOfferToAnvaBySessionIdResponse,
    unknown,
    FuncParams
  >;
}

type FuncParams = {
  sessionId?: string;
};

export const postOfferToAnva = async ({ sessionId }: FuncParams) => {
  const { data, isError } =
    await wgApi.post<SendOfferToAnvaBySessionIdResponse>(
      `/v1/api/anvaflows/${sessionId}/send-offer-to-anva`,
    );
  if (isError) throw new Error(JSON.stringify(data as ErrorResponse));
  return data;
};

export const usePostOfferToAnva = ({ queryOptions = {} }: Params) => {
  const queryClient = useQueryClient();

  return useMutation<SendOfferToAnvaBySessionIdResponse, unknown, FuncParams>(
    postOfferToAnva,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          'parties',
          'insurance-policies',
          'simulations',
        ]);
      },
      ...queryOptions,
    },
  );
};
